module.exports = __webpack_public_path__ + "media/images/logo/Logo-200px 2-7ac24e3dbcb83b5b1f4d2a1e8c67601d.png";